import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { List, ArrowUpRight } from "@phosphor-icons/react";
import { Sheet, SheetContent, SheetTrigger } from "./ui/sheet";
import { TWO_A_URL } from "./EstimateCTA";

const SELL_LINKS = [
  { to: "/sell-your-phone", label: "Phone" },
  { to: "/sell-your-laptop", label: "Laptop" },
  { to: "/sell-your-tablet", label: "Tablet" },
  { to: "/sell-your-smartwatch", label: "Smartwatch" },
  { to: "/sell-your-gaming-console", label: "Gaming Console" },
  { to: "/sell-sealed-electronics", label: "Sealed Electronics" },
];

const NAV = [
  { to: "/how-it-works", label: "How It Works" },
  { to: "/guides", label: "Buyback Guides" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export const Navbar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-black/5 bg-white/80 backdrop-blur-2xl" data-testid="site-header">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-6 md:h-[72px] md:px-12">
        <Link to="/" className="font-display text-base font-extrabold tracking-tight text-navy md:text-lg" data-testid="nav-logo">
          SELL MY PHONE <span className="text-brand">CHICAGO</span>
        </Link>

        <nav className="hidden items-center gap-7 lg:flex" aria-label="Primary">
          <div className="group relative">
            <button className="flex items-center gap-1 text-sm font-medium text-black/80 transition-colors hover:text-brand" data-testid="nav-sell-menu">
              Sell Your Device
            </button>
            <div className="invisible absolute left-0 top-full w-60 pt-3 opacity-0 transition-all duration-200 group-hover:visible group-hover:opacity-100">
              <div className="rounded-2xl border border-black/10 bg-white p-2 shadow-[0_20px_50px_rgb(0,0,0,0.1)]">
                {SELL_LINKS.map((l) => (
                  <NavLink key={l.to} to={l.to} data-testid={`nav-sell-${l.label.toLowerCase().replace(/ /g, "-")}`}
                    className="block rounded-xl px-4 py-2.5 text-sm font-medium text-black/75 transition-colors hover:bg-brand/5 hover:text-brand">
                    Sell Your {l.label}
                  </NavLink>
                ))}
              </div>
            </div>
          </div>
          {NAV.map((l) => (
            <NavLink key={l.to} to={l.to} data-testid={`nav-${l.label.toLowerCase().replace(/ /g, "-")}`}
              className={({ isActive }) => `text-sm font-medium transition-colors hover:text-brand ${isActive ? "text-brand" : "text-black/80"}`}>
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a href={TWO_A_URL} target="_blank" rel="noopener" data-testid="nav-estimate-btn"
            className="group hidden items-center gap-2 rounded-full bg-navy px-5 py-2.5 font-display text-xs font-bold uppercase tracking-[0.12em] text-white transition-colors duration-300 hover:bg-brand sm:flex">
            Get Estimate
            <ArrowUpRight size={14} weight="bold" className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
          <Sheet open={mobileOpen} onOpenChange={setMobileOpen}>
            <SheetTrigger asChild>
              <button className="rounded-full p-2 lg:hidden" aria-label="Open menu" data-testid="nav-mobile-toggle">
                <List size={24} weight="bold" />
              </button>
            </SheetTrigger>
            <SheetContent side="right" className="w-[85vw] max-w-sm bg-white p-8">
              <p className="mb-8 font-display text-lg font-extrabold tracking-tight text-navy">
                SELL MY PHONE <span className="text-brand">CHICAGO</span>
              </p>
              <p className="mb-3 text-xs font-semibold uppercase tracking-[0.25em] text-[#8A8A8A]">Sell your device</p>
              <div className="mb-8 flex flex-col gap-1">
                {SELL_LINKS.map((l) => (
                  <Link key={l.to} to={l.to} onClick={() => setMobileOpen(false)} data-testid={`mobile-sell-${l.label.toLowerCase().replace(/ /g, "-")}`}
                    className="rounded-lg px-2 py-2 font-display text-base font-semibold text-black/85 transition-colors hover:text-brand">
                    Sell Your {l.label}
                  </Link>
                ))}
              </div>
              <div className="flex flex-col gap-1">
                {NAV.map((l) => (
                  <Link key={l.to} to={l.to} onClick={() => setMobileOpen(false)} data-testid={`mobile-${l.label.toLowerCase().replace(/ /g, "-")}`}
                    className="rounded-lg px-2 py-2 font-display text-base font-semibold text-black/85 transition-colors hover:text-brand">
                    {l.label}
                  </Link>
                ))}
              </div>
              <a href={TWO_A_URL} target="_blank" rel="noopener" onClick={() => setMobileOpen(false)} data-testid="mobile-estimate-btn"
                className="mt-8 block w-full rounded-full bg-brand py-3.5 text-center font-display text-sm font-bold uppercase tracking-[0.15em] text-white">
                Get a Buyback Estimate
              </a>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
};
